module.exports = __webpack_public_path__ + "img/camera-frame-corner.0fe51743.svg";